import Vue from "vue";
import {
  Toast
} from 'vant';
import apis from "@/config/api.config.js"
import qs from "qs";


export default {
  name: "regist",
  data() {

    return {
      school_v: '',
      grade_v: '',
      relationship_v: '',
      stuname: '',
      parname: '',
      phone: '',
      showSchool: false,
      showGrade: false,
      showRelationship: false,
      areaList: {}, // 数据格式见 Area 组件文档
      school: [],
      grade: [],
      relationship: [
        "父亲", "母亲"
      ],
      pattern: /^1+[123456789]+\d{9}/,// 电话匹配
    };
  },

  methods: {
    onSubmit(values) {
      const that = this;
      console.log('submit', values);
      let departmentid;
      let gradeid;
      let classnum;
      for(let i = 0; i < that.school.length; i++) {
        if(values['school']==that.school[i]['text']) {
          departmentid = that.school[i]['id']
          for (let j = 0; j < that.school[i].grade.length; j++) {
            if (values['grade'].split(' ')[0] == that.school[i].grade[j]['text']) {
              gradeid = that.school[i].grade[j].id
              classnum = values['grade'].split(' ')[1].replace("班","")
            }
            
          }
        }
      }
      
      
      let toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中',
      });
      let post_data = {
        departmentid,
        gradeid,
        classnum,
        name:that.stuname,
        parname:that.parname,
        parrel:that.relationship_v,
        mobile:that.phone,
        device: localStorage.getItem("luoohutoken"),
        type: 1,
      };
      that
        .axios({
          method: "post",
          // headers: { "Content-Type": "application/x-www-form-urlencoded" },
          // url: apis.getActivityList,
          url: apis.addInfo,
          data: qs.stringify(post_data),
        })
        .then((res) => {
          Toast.clear();// 清除所有弹框
          res = res.data;
          Toast({
            duration: 2000, // 持续展示 toast
            forbidClick: true,
            message: res.msg,
            onClose:function () {
              that.$router.replace('/game')
              // if (res.data.code == 200) {
              //   this.$router.replace('/game')

              // }
              
            }
          });
          
          
          

        })
        .catch((rej) => {
          console.log(rej);
        });
    },
    onConfirm_school(values) {

      this.school_v = values['text'];

      this.grade = values['grade']
      // console.log(values);

      this.showSchool = false;
    },
    onConfirm_grade(values) {
      values[1] = values[1] + '班'
      this.grade_v = values
        //   .filter((item) => !!item)
        //   .map((item) => item.name)
        .join(' ');

      // console.log(values);

      this.showGrade = false;
    },
    onConfirm_relationship(values) {
      this.relationship_v = values
      // console.log(values);
      this.showRelationship = false;
    },
    getDepartmentList() {
      const that = this;
      let toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '提交中',
      });
      let post_data = {
        activity_id: that.id
      };
      that
        .axios({
          method: "post",
          // headers: { "Content-Type": "application/x-www-form-urlencoded" },
          // url: apis.getActivityList,
          url: apis.getDepartmentList,
          data: qs.stringify(post_data),
        })
        .then((res) => {
          // console.log(res);

          Toast.clear();// 清除所有弹框
          res = res.data;
          if (res.status == 200) {
            // console.log(res.msg);


            // let columns = [];
            let school = [];
            for (let i = 0; i < res.msg.length; i++) {
              school.push(
                {
                  text: res.msg[i]['name'],
                  id: res.msg[i]['id'],
                  grade: []
                }
              )
              for (let j = 0; j < res.msg[i]['grades'].length; j++) {
                let grades = res.msg[i]['grades'][j]
                let itemson = {
                  text: grades['name'],
                  id: grades['id'],
                  children: []
                }
                school[i].grade.push(itemson)
                // console.log(item);
                for (let k = 0; k < grades['class_count']; k++) {
                  // console.log(school,grades,k+1);
                  let itemgrandson = {
                    text: k + 1
                  }
                  itemson.children.push(itemgrandson)
                  // console.log(itemgrandson);

                }
              }

            }

            console.log(school);
            that.school = school;

          }
        })
        .catch((rej) => {
          console.log(rej);
        });
    },
  },
  created() {
    const that = this;
    // that.id = that.$route.query.id;
    // that.type = that.$route.query.type;
  },
  mounted() {
    const that = this;

    that.getDepartmentList();


    // if (that.type == 0) {
    //   that.hasIdentify = true;
    //   that.getQuestions()
    // } else {
    //   that.checkUserId();

    //   that.getIdList();
    // }

  },
};